module.exports = __webpack_public_path__ + "img/e.567f766c.jpg";